import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('intelligentOutboundCallStore', 'marketingSmsManagementStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: this.props?.location?.state?.addModalVisible || false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {intelligentOutboundCallStore, marketingSmsManagementStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    intelligentOutboundCallStore.onSearchJobAction({
      page: 1, 
      size: PAGE_SIZE_DEFAULT, 
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    marketingSmsManagementStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser
    })
    intelligentOutboundCallStore.onGetStatus('AiApproveStatus')
    intelligentOutboundCallStore.onGetStatus('AiTaskStatus')
  }

  handleSearch = () => {
    const {intelligentOutboundCallStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'marketGroupId': fieldsValue.groupName,
        "taskName": fieldsValue.taskName,
        "taskStatus": fieldsValue.taskStatus,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      intelligentOutboundCallStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    const { marketingSmsManagementStore } = this.props
    marketingSmsManagementStore.onGenerateIDAction().then(response=> {
      if (response?.data?.code === 0) {
        this.setState({
          addModalVisible: true
        })
      }
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {intelligentOutboundCallStore, marketingSmsManagementStore, location, t} = this.props
    const { taskList } = intelligentOutboundCallStore
    const { groupList } = marketingSmsManagementStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="groupName" label={t(`outboundCall.groupName`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="taskName" label={t(`outboundCall.taskName`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`outboundCall.taskName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="taskStatus" label={t(`outboundCall.taskStatus`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {taskList?.map(item => (<Select.Option key={item.id} value={item.code}>{item.name}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          onSearch={this.handleSearch}
          location={location}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
